import {API_ROOT_URL} from 'envs/_current/config'
import {schema} from 'normalizr'
import {createListTransform} from './utils/createListTransform'
import {createTransform} from './utils/createTransform'

export const religiousOrderSchema = new schema.Entity(
  'religious_orders',
  {},
  {
    idAttribute: 'idname',
  }
)

// Route::get('religious-orders/religious-order/{id}/get', 'ReligiousOrderController@getById');
export const religiousOrder_getById_Api = {
  backend: `Route::get('religious-orders/religious-order/{id}/get', 'ReligiousOrderController@getById');`,
  root: API_ROOT_URL,
  path: '/religious-orders/religious-order/:id/get',
  method: 'GET',
  schema: religiousOrderSchema,
  transform: createTransform(religiousOrderSchema, 'data'),
}
// Route::get('religious-orders/religious-order/gets', 'ReligiousOrderController@getReligiousOrders');
export const religiousOrder_getReligiousOrders_Api = {
  backend: `Route::get('religious-orders/religious-order/gets', 'ReligiousOrderController@getReligiousOrders');`,
  root: API_ROOT_URL,
  path: '/religious-orders/religious-order/gets',
  method: 'GET',
  paramsFields: ['sort_by', 'public', 'active', 'keyword',
    'religious_order_group', 'target_gender', 'country_id', 'diocese_id', 'authority_typecd', 'nature_typecd'],
  schema: religiousOrderSchema,
  transform: createListTransform(religiousOrderSchema),
}

export const religiousOrder_getReligiousOrderRecommendInfo_Api = {
  backend: `Route::get('religious-orders/recommend-info/get', 'ReligiousOrderController@getReligiousOrderRecommendInfo');`,
  root: API_ROOT_URL,
  path: '/religious-orders/recommend-info/get',
  method: 'GET',
  paramsFields: ['country_id'],
}

// Route::post('religious-orders/religious-order/create-new', 'ReligiousOrderController@createReligiousOrder');
export const religiousOrder_createReligiousOrder_Api = {
  backend: `Route::post('religious-orders/religious-order/create-new', 'ReligiousOrderController@createReligiousOrder');`,
  root: API_ROOT_URL,
  path: '/religious-orders/religious-order/create-new',
  method: 'POST',
  paramsFields: [],
  schema: religiousOrderSchema,
  transform: createTransform(religiousOrderSchema, 'data'),
}
// Route::post('religious-orders/religious-order/{id}/update', 'ReligiousOrderController@updateReligiousOrder');
export const religiousOrder_updateReligiousOrder_Api = {
  backend: `Route::post('religious-orders/religious-order/{id}/update', 'ReligiousOrderController@updateReligiousOrder');`,
  root: API_ROOT_URL,
  path: '/religious-orders/religious-order/:id/update',
  method: 'POST',
  paramsFields: [],
  schema: religiousOrderSchema,
  transform: createTransform(religiousOrderSchema, 'data'),
}
// Route::post('religious-orders/religious-order/{id}/delete', 'ReligiousOrderController@deleteReligiousOrder');
export const religiousOrder_deleteReligiousOrder_Api = {
  backend: `Route::post('religious-orders/religious-order/{id}/delete', 'ReligiousOrderController@deleteReligiousOrder');`,
  root: API_ROOT_URL,
  path: '/religious-orders/religious-order/:id/delete',
  method: 'POST',
  paramsFields: [],
  schema: religiousOrderSchema,
  transform: createTransform(religiousOrderSchema, 'data'),
}

// Route::get('journey-to-christ/catechesis-video/gets', 'AppController@getNewChrist');
export const get_video_stage_1_Api = {
  backend: `Route::get('journey-to-christ/catechesis-video/gets', 'AppController@getCatechesisVideo');`,
  root: API_ROOT_URL,
  path: '/journey-to-christ/catechesis-video/gets',
  method: 'GET',
}
// Route::get('journey-to-christ/catechesis-video-stage-2/gets', 'AppController@getCatechesisVideoStage2');
export const get_video_stage_2_Api = {
  backend: `Route::get('journey-to-christ/catechesis-video-stage-2/gets', 'AppController@getCatechesisVideoStage2');`,
  root: API_ROOT_URL,
  path: '/journey-to-christ/catechesis-video-stage-2/gets',
  method: 'GET',
}